import { render, staticRenderFns } from "./UserReviewLinks.vue?vue&type=template&id=64f1b9ba"
import script from "./UserReviewLinks.vue?vue&type=script&lang=js"
export * from "./UserReviewLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports